<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0050_approval_history</div>
        <!-- <app-header>esma</app-header> -->
        <div :class="'container ' + pageContainerSize">
          <!-- <title-and-search title="申請承認"></title-and-search> -->
          <search-control 
          style="padding-bottom: 10px;"
          :field_names="allSearchFields" @change="searchControlChangedDatasource"></search-control>
          <div>
            <input 
              @click="allChecked($event.target.value,$event.target)"
              style="float: right;"
              v-model="checkBoxSelectAll"
              :disabled="approveMode == 'reject'"
              type="checkbox" id="checkBoxSelectAll" name="checkBoxSelectAll" value="X">
          </div>
          <div>
            <ag-grid-vue style="width: 100%; height: 325px" class="ag-blue" :gridOptions="gridOptions" ></ag-grid-vue>
            <br>
          </div>
          <div style="float: left;;margin-top:5px">
            件数
            </div>
            <input type="text" data-cy="totalNumberOfRows" style="width: 5%;text-align: right;float: left;margin-left:5px" class="form-control limited-height-box" :disabled="true" :value="totalNumberOfRows" />
          <div style="margin-top:5px;">
            <button :disabled="true || checkUserPermission(true,permissionMode.EDIT) == false" class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;" @click="bulkApprovalStage4" >申請クリア</button>
            <button 
            :disabled="disablePageApprove || checkUserPermission(true,permissionMode.EDIT) == false" 
            class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #92D050;border-color:#92D050;" 
            @click="bulkApprovalStage1" >承認</button>

            <button
              :disabled="disablePageReject || checkUserPermission(true,permissionMode.EDIT) == false"
              @click="bulkRejectStage1"
              class="btn btn-danger" style="min-width:100px;width: 7%;float: right;margin-right: 10px;">差戻</button>
          </div>
        </div>
        <confirmation-modal tag="stage1ConfirmatioModal" @done="bulkApprovalStage2" />
        <confirmation-modal tag="stage2ConfirmatioModal" @done="bulkApprovalStage3" />
        <information-icon-modal tag = "showInformationIconModalApprovalHistoryAll"/>
        <confirmation-modal tag="stage1RejectConfirmatioModal" @done="bulkRejectStage2" />
        <progress-modal tag="showApproveProgressModal" hide_tag="hideApproveProgressModal"/>
    </div>
</template>

<script>
import Vue from 'vue';
import { AgGridVue } from 'ag-grid-vue';
import { fields, filed_types } from '@/rules/fields_approval_history';
import { utils } from '@/libs/utils';


import md5 from 'md5';
import _debug from 'debug';
var mdebug = _debug('esma:approval_history');
import fieldBoxes from '@/components/form-field';
import moment from "moment";
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import constants from "@/rules/constants";
import progressModal from '@/components/modals/progress-modal';


import { bus } from '@/libs/bus';

export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'field-box': fieldBoxes,
    'ag-grid-vue': AgGridVue,
    'progress-modal':progressModal
  },
  data() {
    return {
      api_name:"approval_history_batch_import",
      row_data: [],
      data_values: {},
      data_values_original: {},
      selected_row: -1,
      last_notify_about_data_updated: 0,
      filter_list: [],
      filter_changed: false,
      forceSelectOnReturn: false,
      execute_filter_on_back:true,
      page_acl: acl.approval_history,
      user_id:"",
      is_logged_user_admin:false,
      load_only_with_filter:false,
      disable_page_approve:true,
      selected_session_ids_for_approve:[],
      get_row_style_background:"orange",
      approve_mode :"none",
      select_all:false
    };
  },
  computed: {
    checkBoxSelectAll:{
      get(){
        return this.select_all;
      },
      set(v){
        this.select_all = v;
      }
    },
    approveMode:{
      get(){
        return this.approve_mode;
      },
      set(v){
        this.approve_mode = v;
      }
    },
    getRowStyleBackground:{
      get(){
        return this.get_row_style_background;
      },
      set(v){
        this.get_row_style_background = v;
      }
    },
    disablePageReject:{
      get(){
        if(this.approveMode !="reject"){
          return true;
        }
        if(this.formOutputQty == 0 ){
          return true;
        }else{
          return false;
        }
        // return this.disable_page_approve;
      },
      set(v){
        this.disable_page_approve = v;
      }
    },
    disablePageApprove:{
      get(){
        if(this.approveMode =="reject"){
          this.$emit("bRLFlag",!true);
          return true;
        }
        if(this.formOutputQty == 0 ){
          this.$emit("bRLFlag",!true);
          return true;
        }else{
          this.$emit("bRLFlag",!false);
          return false;
        }
        // return this.disable_page_approve;
      },
      set(v){
        this.disable_page_approve = v;
      }
    },
    isLoggedUserAdmin:{
      get(){
        return this.is_logged_user_admin;
      },
      set(v){
        this.is_logged_user_admin = v;
      }
    },
    userId:{
      get(){
        return this.user_id;
      },
      set(v){
        this.user_id = v;
      }
    },
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    values() {
      console.log('values');
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    allSearchFields(){
      return [
          fields.control_number,
          fields.approval_status,
          fields.syubetu,
          fields.toroku_number,
          fields.applicant_label,
          fields.next_approver_label,
          fields.update_name_label,
          fields.create_time,
          fields.update_time

      ]
    },
    tabFieldList() {
      return [
        utils.extend(fields.approval_status, {
          options: [
            "承認済",   // Approved
            "申請中",   // Applying
            "差戻",     //Reject
            "確認済"    // Confirmed
          ]
        }),
        utils.extend(fields.syubetu, {}),
        // utils.extend(fields.control_number, {}),
        utils.extend(fields.toroku_number, {}),

        utils.extend(fields.applicant_label, {}),
        utils.extend(fields.next_approver_label, {}),
        utils.extend(fields.update_name_label, {}),

        utils.extend(fields.create_time, {}),
        utils.extend(fields.update_time, {}),
      ];
    }
  },
  methods: {
    onArraySelected(){
      this.$emit("selectedItemsUpd",this.selectedRowArr.length);
    },
    allChecked(a,b){
      this.commonAllChecked("showInformationIconModalApprovalHistoryAll",(err,qty)=>{
        this.$emit("selectedItemsUpd",qty);
      })
    },
    hideInternalCheckBox(data){
      if(data){
        if(data["applicant"] == this.userId){
        // if(data["applicant"] == this.userId && (!(data.next_approver == "ライセンス管理窓口（最終承認）" && this.isApproverAdminForApproveImport ))){// Sestting it, the onw uploader, may also reject.
          return true;
        }
        if(data.checked_to_reject == 1){
          if(data.checked_user == null || data.checked_user == '' || data.checked_user == this.userId){
            // Is not selected or selected by own user.
          }else{
            return true;
          }
        }
        var found_to_hide = false;
        [1,2,3,4,5].forEach((f) => {
          if(data["approver_" + f] == this.userId && data["status_" + f] != "未承認" ){
            found_to_hide = true;
          }
        })

        if(data.status_final != "未承認" && data.status_final != ""  && data.status_final != null) {
          return true;
        }
        if(found_to_hide == true){
          return true;
        }
      }
      return false;
    },
    hideCheckBox(data){
      if(this.approveMode == "reject"){
        return true;
      }
      if(data){
        var found_to_hide = false;
        [1,2,3,4,5].forEach((f) => {
          if(data["approver_" + f] == this.userId && data["status_" + f] != "未承認" ){
            found_to_hide = true;
          }
        })
        if(found_to_hide == true){
          return true;
        }
      }
      if(data && data.checked_to_reject == 1){
        return true;
      }else if(data && (data.next_approver == this.userId  || (data.next_approver == "ライセンス管理窓口（最終承認）" && this.isApproverAdminForApproveImport  && data.applicant != this.userId ))){ 
        return false
      }else{
        return true;
      }
    },
    bulkRejectStage1(){
      var arr = _.filter(this.selectedRowArr,(r)=>{return r.checked_to_reject == 1}).map((m)=>{return m.ref_id;})
      if(Array.isArray(arr) == false || arr.length < 1){
        this.$notify({
            title: "行の選択に失敗しました。",
            text:"",
            type: "error",
            duration: 10000
          });
          return;
      }
      this.selected_session_ids_for_reject = arr;
      this.$ajax.post("/"+this.api_name+"/count_prepared", {ref_id_list:arr}, (err, qty) => {
        console.log({qty})
        if(err){
        this.$notify({
            title: "データの差戻に失敗しました。",
            text:err,
            type: "error",
            duration: 10000
          });
        }else{

          bus.$emit("stage1RejectConfirmatioModal",{
            title: "選択中　"+qty+"件",
            message: "差戻を行います。よろしいですか？",
            yes_label: "差戻",
            no_label: "戻る",
            yes_color:"danger",
            no_color:"default",
            model_height:"50"
          })
        }
      });

    },
    bulkRejectStage2(mode){
      if(mode != "yes"){
        return;
      }
      var arr = this.selected_session_ids_for_reject
      this.$ajax.post("/"+this.api_name+"/reject_it", {ref_id_list:arr}, (err, response) => {
        this.selected_session_ids_for_reject = []
        this.selectedRowArr = []
        this.formOutputQty = 0;
        console.log({response})
        this.$store.state["current_field_style"] = {};
        this.$store.state["current_field_style2"] = {};
        if(err){
        this.$notify({
            title: "データの差戻に失敗しました。",
            text:err,
            type: "error",
            duration: 10000
          });
        }else{
          this.gridOptions.api.purgeInfiniteCache();
                var message = "自動でメール通知はされませんので、口頭または<br>メールで差戻したことを申請者へお伝えください。";    
                bus.$emit("stage2ConfirmatioModal",{
                  message: message,
                  title: "申請が差戻されました",
                  yes_label: "",
                  no_label: "OK",
                  yes_color:"",
                  no_color:"",
                  model_height:"50",
                  model_width: "390px"
          })
        }
      });
    },
    bulkApprovalStage1(){
      /**
       * 1 - Show onfirmation screen
       */

      var arr = this.selectedRowArr.map((m)=>{return m.ref_id;})
      this.selected_session_ids_for_approve = arr;
      this.$ajax.post("/"+this.api_name+"/count_prepared", {ref_id_list:arr}, (err, qty) => {
        console.log({qty})
        if(err){
        this.$notify({
            title: "データの承認に失敗しました。",
            text:err,
            type: "error",
            duration: 10000
          });
        }else{
          console.log("bulkApprovalStage1",{qty})
          // this.gridOptions.api.purgeInfiniteCache();
          bus.$emit("stage1ConfirmatioModal",{
            title: "選択中　"+qty+"件",
            message: "承認を行います。よろしいですか？",
            yes_label: "承認",
            no_label: "戻る",
            yes_color:"info",
            no_color:"default",
            model_height:"50"
          })
        }
      });
    },
    bulkApprovalStage2(mode){
      /**
       * 2 - When aprove, execute at the server
       * 3 - Then show the results message.
       */
      if(mode != "yes"){
        return;
      }
      this.disablePageApprove = true;
       bus.$emit("showApproveProgressModal",{
        title: "データを処理します。", 
        message: "しばらくお待ちください。",
        model_height:"50"
      })
      var arr = this.selected_session_ids_for_approve
      this.$ajax.post("/"+this.api_name+"/approve", {ref_id_list:arr}, (err, response) => {
        setTimeout(()=>{
        bus.$emit("hideApproveProgressModal",{})
        },500)
        this.disablePageApprove = false;
        this.selected_session_ids_for_approve = []
        this.selectedRowArr = []
        this.formOutputQty = 0;
        console.log({response})
        this.$store.state["current_field_style"] = {};
        this.$store.state["current_field_style2"] = {};
        if(err){
          this.$notify({
            title: "データの承認に失敗しました。",
            text:err,
            type: "error",
            duration: 10000
          });
        }else{
          setTimeout(()=>{
            bus.$emit("stage2ConfirmatioModal",{
              title: "承認が完了しました。", 
              message: "",
              yes_label: "",
              no_label: "戻る",
              yes_color:"info",
              no_color:"default",
              model_height:"50"
            })
            this.gridOptions.api.purgeInfiniteCache();
          },300)

        }
      });

    },
    bulkApprovalStage3(){
      this.gridOptions.api.purgeInfiniteCache();
      this.countRows("bulkApprovalStage3");
    },
    bulkApprovalStage4(mode){
      /**
       * 2 - When aprove, execute at the server
       * 3 - Then show the results message.
       */
      // if(mode != "yes"){
      //   return;
      // }
      this.$ajax.post("/"+this.api_name+"/approve_clear", {}, (err, response) => {
        console.log({response})
        if(err){
        this.$notify({
            title: "データの承認に失敗しました。",
            text:err,
            type: "error",
            duration: 10000
          });
        }else{
          this.gridOptions.api.purgeInfiniteCache();
            bus.$emit("stage2ConfirmatioModal",{
            title: "クリア", 
            message: "確認をクリアしました。",
            yes_label: "",
            no_label: "戻る",
            yes_color:"info",
            no_color:"default",
            model_height:"50"
          })
        }
      });

    },
    onDetailsClick(ev, data) {
      if(this.hideInternalCheckBox(data) == true){
        var destination = "/approval_history/detail/" + data.ref_id + "/"+md5("HIDE" + data.ref_id )
      }else{
        var destination = "/approval_history/detail/" + data.ref_id + "/"+md5("SHOW" + data.ref_id )
      }
      return this.$router.push(destination);
    },
    createColumnDefs() {
      return this.commonCreateColumnDefs({show_details:true,show_checkbox:true})
    }
  },
  mounted() {
    this.gridOptions.api.sizeColumnsToFit();
    if(this.$route.meta.mode =="rejected"){
      setTimeout(() => {
        bus.$emit("onOpenPageFilter",{field:"approval_status",val:'差戻'})
      }, 200);
    }else{
      bus.$emit("onSearchClear",{})
    }
    this.userId = Vue.localStorage.get("userID") || "";
    this.isLoggedUserAdmin = this.isApproverAdminForApproveImport ;
    this.$emit("selectedItemsUpd",0);
  },
  beforeDestroy() {
    bus.$emit("onSearchClear",{})
  },
  beforeMount() {
    this.$store.state[this.stateCurrentRow]= {};
    var use_data_source = true;

    //AG Grid options
    this.gridOptions = {
      defaultColDef: {
        editable: false
      },
      getRowNodeId: (data) => {
        return data.seq_id;
      },
      enableSorting: true,
      enableColResize: true,
      suppressMovableColumns: true,
      rowSelection: 'single',
      suppressHorizontalScroll: true,
      overlayNoRowsTemplate :"<span class=\"ag-overlay-loading-center\">対象のデータはありません</span>",
      onColumnResized: (ev, b) => {
      },
      onRowSelected: ev => {
      },
      onModelUpdated: (ev, d) => {
      },
      onGridReady:() => {

      },
      getRowStyle: params => { 
        if((this.isLoggedUserAdmin == true && params.node.data  && params.node.data.status_final == "未承認") || this.approveMode == "reject" || (params.node.data  && params.node.data.next_approver == this.userId)){
          if (params.node.data && params.node.data.checked_to_reject == 1 &&  params.node.data.checked_user == this.userId && (params.node.data.is_selected == true || this.isAllSelected == true)) {
            return { background: "#ffb5b5" };
          }else if(params.node.data && params.node.data.checked_to_reject == 1 && (params.node.data.is_selected == true || this.isAllSelected == true)) {
            return {  };
          }else if (params.node.data && (params.node.data.is_selected == true || this.isAllSelected == true)) {
            return { background: "orange" };
          }
        }
      },
    };
    this.initDatasource({load_only_with_filter:false,loaded_cb:(err,data,vm)=>{

      // vm.init_data_source_options.load_only_with_filter = false;
      // vm.load_only_with_filter = false;
      var active_approve_button = _.find(data,(d)=>{
        return ((this.isLoggedUserAdmin == true && d  && d.status_final == "未承認") || (d  && d.next_approver == this.userId)) && (d && (d.is_selected == true || this.isAllSelected == true))
      })
      this.disablePageApprove = typeof active_approve_button == "undefined";
      var found = false;
      _.filter(data,(r)=>{ return r.checked_to_reject == 1 && r.checked_user == this.userId}).forEach(e=>{
          if(this.hideInternalCheckBox(e) == false){
            this.onSelectedClickDatasource({},e)
            found  = true
          }
      })
      this.approveMode = (found)?"reject":"approve";
    }});
  }
};

</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// approval_history_all.vue?30512d75